export enum paymentLinkStatus {
  active = "active",
  deactivated = "deactivated",

  // draft,
  // paid,
  // overdue,
  // outstanding,
}
